import { render, staticRenderFns } from "./stock.vue?vue&type=template&id=61dca764"
import script from "./stock.vue?vue&type=script&lang=js"
export * from "./stock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61dca764')) {
      api.createRecord('61dca764', component.options)
    } else {
      api.reload('61dca764', component.options)
    }
    module.hot.accept("./stock.vue?vue&type=template&id=61dca764", function () {
      api.rerender('61dca764', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GpsViews/Admin/Plants/Plant/Production/checkup/stock.vue"
export default component.exports